import React from "react"
import JobsComponent from "../../components/Jobs"
import Layout from "../../components/layout"

const DeveloperPage = () => (
  <Layout>
    <div>
      <JobsComponent
        image="https://i.postimg.cc/26ZxLFjx/Emerald-Water.png"
        title="A dreamer who wishes to build in order to empower and delight."
        intro="We're looking for an iOS developer to help accelerate our mission. You will expand the story editor: adding new features and creating new checks to avoid any misuse of the platform. You will also advance our Community by offering a more personalized layout that encourages users everywhere to step up and spaek out."
        skills="Our app is native, taking advantage of the many frameworks Apple gives us. It is built entirely with Swift. Experience with Firebase and JavaScript is an advantage."
        end="We're looking for someone sharp, internally-driven, and passionate about the future of the honest spread of information. If you're interested, shoot us a note to ceo@viewsnews.co."
      />
    </div>
  </Layout>
)

export default DeveloperPage
